/* eslint-disable */
export const maxLifetime = 14

export default [
[ 0, 1000 ],
[ 1, 801 ],
[ 2, 789 ],
[ 3, 776 ],
[ 4, 764 ],
[ 5, 734 ],
[ 6, 688 ],
[ 7, 640 ],
[ 8, 571 ],
[ 9, 439 ],
[ 10, 252 ],
[ 11, 96 ],
[ 12, 6 ],
[ 13, 3 ],
[ 14, 0 ]
]
